/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { getStylist } from 'src/core/themes/luisStylist';

const { styleDiv } = getStylist('Toaster');

const ToasterPortalContainer = styleDiv('ToasterPortalContainer', theme => ({
    background: 'transparent',
    position: 'fixed',
    zIndex: (theme.containerZIndex as unknown) as number,
    top: theme.containerTop,
    right: 0,
    pointerEvents: 'none',
    maxHeight: '100%',
    padding: theme.containerPadding,
    $nest: {
        '& .toast-enter': {
            transform: 'translate3d(150%, 0, 0)'
        },
        '& .toast-enter-active': {
            transform: 'translate3d(0, 0, 0)',
            transition: 'transform 250ms cubic-bezier(0.2, 0, 0, 1)'
        },
        '& .toast-exit': {
            transform: 'translate3d(0, 0, 0)'
        },
        '& .toast-exit-active': {
            transform: 'translate3d(150%, 0, 0)',
            transition: 'transform 250ms cubic-bezier(0.2, 0, 0, 1)'
        }
    }
}));

/**
 * Renders a container that displays toasts. This container
 * is floating in the top right of the page.
 *
 * @param props The children (toasts) to display.
 */
export const ToasterPortal = (props: React.PropsWithChildren<object>) => ReactDOM.createPortal(<ToasterPortalContainer>{props.children}</ToasterPortalContainer>, document.body);
